/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateOrganisationListDataSchema = z.object({
	organisations: z.array(z.object({ id: z.string(), name: z.string(), candidacyCount: z.number() })),
})

export type CandidateOrganisationListDataSchema = z.infer<typeof candidateOrganisationListDataSchema>
